<template>
  <div :class="$style.wrap">
    <div :class="$style.list_header">
      <div :class="$style.funnel_icon"></div>
      <span @click="orderScreening">筛选订单</span>
    </div>
    <div :class="$style.list_warpper">
      <van-list
        :class="$style.list_content"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="finishedText"
        offset="10"
        @load="getList"
      >
        <div
          :class="[$style.invoice_info, item.status && $style.over_use]"
          v-for="(item, id) in list"
          :key="id"
          @click="checkInvoice(item)"
        >
          <div
            v-if="!item.status"
            :class="[
              hasChecked(item.id) ? $style.item_checked : $style.item_unChecked
            ]"
          ></div>
          <div v-else :class="$style.item_use_chekced"></div>

          <div :class="$style.item_info">
            <span>{{ item.recharge_date }}</span>
            <span>{{ item.recharge_way }}</span>
          </div>
          <div :class="$style.item_unit">
            <span>{{ toFixed(item.recharge_num) }}</span>
            <span>元</span>
          </div>
          <div v-if="item.status" :class="$style.item_use"></div>
        </div>
      </van-list>
    </div>

    <div :class="$style.check_info">
      共选{{ checkedIdList.length }}个订单，共计{{ amount }}元
    </div>
    <div :class="$style.list_footer">
      <div :class="$style.list_footer_item" @click="selectAllSelection">
        <div
          v-if="!allHalf"
          :class="[allSelection ? $style.item_checked : $style.item_unChecked]"
        ></div>
        <div v-else :class="$style.item_half"></div>
        <span> 所有未开票 </span>
      </div>
      <button :class="$style.list_footer_btn" @click="nextSumbit">
        下一步
      </button>
    </div>

    <van-popup
      v-model="showPopup"
      position="right"
      :class="$style.popup_content"
    >
      <select-type ref="selectType" />
      <div :class="$style.popup_content_btn">
        <button @click="cancel">取消</button>
        <button @click="sure">确定</button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getOrder, getCanOrderInfo } from "@/http/invoice";
import SelectType from "./commpents/SelectType";
export default {
  name: "invoiceList",
  data() {
    return {
      timer: null,
      allAmout: 0,
      allHalf: false,
      finishedText: "",
      orderNum: 0,
      amount: 0,
      allSelection: false,
      checkedIdList: [],
      total: 0,
      showPopup: false,
      list: [],
      loading: false,
      finished: false,
      pageSize: 10,
      currentPage: 1
    };
  },
  components: {
    SelectType
  },
  mounted() {
    this.initGetList();
  },
  methods: {
    toFixed(num) {
      let number = 0;
      number = Number(Number(num).toFixed());
      return number;
    },
    sure() {
      this.$refs.selectType.setActive();
      this.showPopup = false;
      this.initGetList();
    },
    initGetList() {
      this.checkedIdList = [];
      this.currentPage = 1;
      this.list = [];
      this.finishedText = "";
      this.finished = false;
      this.loading = true;
      this.allSelection = false;
      this.total = 0;
      this.amount = 0;
      this.orderNum = 0;
      this.allAmout = 0;
      this.allHalf = false;
      this.getList();
    },
    cancel() {
      this.$refs.selectType.setSessionAcitve();
      this.showPopup = false;
    },
    nextSumbit() {
      if (this.total === 0) {
        this.$Toast("暂无可开发票");
        return false;
      }
      if (!this.checkedIdList.length) {
        this.$Toast("请选择要开票的订单");
        return false;
      }
      this.$router.replace({
        path: this._anchor.invoiceMake.path,
        query: {
          amount: this.amount,
          number: this.orderNum,
          orderIds: JSON.stringify(this.checkedIdList)
        }
      });
    },
    async selectAllSelection() {
      if (this.total === 0) {
        this.$Toast("暂无可开发票");
        return false;
      }
      if (!this.$ls.get("gameActive") || !this.$ls.get("gameActive")) {
        return false;
      }
      this.allSelection = !this.allSelection;
      this.allHalf = false;
      if (this.allSelection) {
        let res = await getCanOrderInfo({
          game_id: this.$ls.get("gameActive"),
          time_bucket: this.$ls.get("timeActive")
        });

        if (res.data) {
          const { sum, num, order_ids } = res.data;
          this.amount = this.toFixed(sum);
          this.orderNum = num;
          this.checkedIdList = order_ids;
          this.allAmout = this.amount;
        } else if (res.rcode === 6002) {
          this.timer = setTimeout(() => {
            this.$router.replace({
              path: this._anchor.invoiceRules.path
            });
          }, 3000);
        }
      } else {
        this.checkedIdList = [];
        this.amount = 0;
        this.orderNum = 0;
        this.allAmout = 0;
      }
    },
    hasChecked(id) {
      if (this.checkedIdList.includes(id)) {
        return true;
      } else {
        return false;
      }
    },

    checkInvoice(item) {
      if (item.status) {
        this.$Toast("此订单已开过发票，不可重复选择");
        return false;
      }
      if (this.checkedIdList.includes(item.id)) {
        this.checkedIdList = this.checkedIdList.filter(id => {
          return item.id !== id;
        });
      } else {
        this.checkedIdList.push(item.id);
      }

      this.orderNum = this.checkedIdList.length;
      if (this.allSelection || this.allHalf) {
        if (this.checkedIdList.length) {
          let amountList = this.list
            .filter(item => {
              return !this.checkedIdList.includes(item.id) && !item.status;
            })
            .map(item => {
              return this.toFixed(item.recharge_num);
            });

          let removeAmount = 0;
          if (amountList && amountList.length > 0) {
            removeAmount = amountList.reduce((pre, next) => {
              return pre + next;
            });
          }

          this.amount = this.allAmout - removeAmount;
          this.allHalf = true;
        } else {
          this.amount = 0;
          this.allHalf = false;
        }
        this.allSelection = false;
      } else {
        if (this.checkedIdList.length > 0) {
          let amountList = this.list
            .filter(item => {
              return this.checkedIdList.includes(item.id);
            })
            .map(item => {
              return this.toFixed(item.recharge_num);
            });

          if (amountList && amountList.length > 0) {
            this.amount = amountList.reduce((pre, next) => {
              return pre + next;
            });
          }
        } else {
          this.amount = 0;
          this.allHalf = false;
          this.allSelection = false;
        }
      }

      if (this.finished) {
        let hasCanList = this.list.filter(item => {
          return !item.status;
        });
        if (this.checkedIdList.length === hasCanList.length) {
          this.allSelection = true;
          this.allHalf = false;
          let amountList = hasCanList.map(item => {
            return this.toFixed(item.recharge_num);
          });
          if (amountList && amountList.length > 0) {
            this.amount = amountList.reduce((pre, next) => {
              return pre + next;
            });
            this.allAmout = this.amount;
          }
        }
      }
    },
    orderScreening() {
      this.showPopup = true;
    },

    async getList() {
      if (!this.$ls.get("gameActive") || !this.$ls.get("gameActive")) {
        this.$router.replace({
          path: this._anchor.invoiceRules.path
        });
        return false;
      }
      let parmas = {
        game_id: this.$ls.get("gameActive"),
        time_bucket: this.$ls.get("timeActive"),
        current: this.currentPage
      };

      let res = await getOrder(parmas);
      this.loading = false;
      if (res.data) {
        const { total, list, current } = res.data;
        this.total = total;
        if (this.currentPage > 1) {
          this.list = [...this.list, ...list];
        } else {
          this.list = list;
        }

        if (total > 0) {
          // 如果总页数大于当前页码，页码+1
          if (total / 10 > current) {
            this.currentPage++;
          } else {
            this.finished = true;
            this.finishedText = "- 没有更多了-";
          }
        } else {
          this.finished = true;
          this.finishedText = "- 暂无数据-";
        }
      } else if (res.rcode === 6002) {
        this.timer = setTimeout(() => {
          this.$router.replace({
            path: this._anchor.invoiceRules.path
          });
        }, 3000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style module lang="less">
:global {
  html #app,
  body #app {
    height: 100%;
  }
  #app {
    & > div {
      height: 100%;
    }
  }
}
.wrap {
  position: relative;
  height: calc(100% - 1.1rem);
}

.list {
  &_header {
    height: 0.8rem;
    padding: 0 0.3rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.24rem;
  }
  &_warpper {
    .size(100%, calc(100% - 2.6rem));
    overflow-y: scroll;
  }

  &_footer {
    .size(100%, 1rem);
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    border-top: 1px solid #e5e6e8;
    &_item {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.5rem;
      span {
        margin-left: 0.2rem;
      }
    }
    &_btn {
      .size(2rem, 1rem);
      position: absolute;
      right: 0;
      background-color: #48d5af;
      border: none;
      color: #fff;
    }
  }
}
.funnel_icon {
  .size(0.35rem);
  background-image: url("./images/funnel.png");
  background-size: 100% 100%;
  margin-right: 0.1rem;
}

.popup_content {
  .size(60%, 100%);

  &_btn {
    position: fixed;
    bottom: 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    & > button {
      padding: 0.1rem 0.5rem;
      font-size: 0.28rem;
    }
    & > button:first-child {
      border: 1px solid #48d5af;
      color: #48d5af;
      background-color: #fff;
      margin-right: 0.35rem;
    }
    & > button:last-child {
      background-color: #48d5af;
      border: 1px solid #48d5af;
      color: #fff;
    }
  }
}

.invoice_info {
  .size(6.9rem, 1rem);
  margin: auto;
  border-bottom: 1px solid #e5e6e8;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0.2rem 0;
  position: relative;
}
.item {
  &_use {
    .size(1rem);
    position: absolute;
    top: 0.2rem;
    right: 1.6rem;
    background-image: url("./images/use.png");
    background-size: 100% 100%;
  }
  &_checked {
    .size(0.35rem);
    background-image: url("./images/select.png");
    background-size: 100% 100%;
  }
  &_half {
    .size(0.35rem);
    background-image: url("./images/half.png");
    background-size: 100% 100%;
  }
  &_use_chekced {
    .size(0.3rem);
  }
  &_unChecked {
    .size(0.3rem);
    border: 1px solid #bfbfbf;
    border-radius: 50%;
  }
  &_info {
    .size(4rem, 100%);
    position: relative;
    margin: auto 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
      display: inline-block;
      line-height: 0.4rem;
      letter-spacing: 0.02rem;
      color: #79808c;
      font-size: 0.26rem;
    }
  }
  &_unit {
    .size(1.8rem, 100%);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    span {
      color: #4f5766;
    }
    span:first-child {
      font-size: 0.3rem;
      font-weight: 500;
    }
    span:last-child {
      font-size: 0.16rem;
      margin: 0.05rem 0 0 0.05rem;
    }
  }
}
.over_use {
  .item_info {
    span {
      color: #bfbfbf;
    }
  }
  .item_unit {
    & > span {
      color: #bfbfbf;
    }
  }
}
.check_info {
  padding: 0.2rem 0.5rem;
  letter-spacing: 0.03rem;
  border-top: 1px solid #e5e6e8;
}
</style>
